import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
  OnChanges,
  ViewChild,
  AfterViewInit,
  ElementRef,
} from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, Params } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { lastValueFrom } from "rxjs/internal/lastValueFrom";
import { Validators } from "@angular/forms";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { ConfirmationService } from "primeng/api";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { GetUserDto } from "../../../../core/models/users/users/getUserDto";
import { ConfirmUserEmailDto } from "../../../../core/models/users/users/confirmUserEmailDto";
import { Biller } from "../../../../core/models/users/billers/billerDto";
import { Collector } from "../../../../core/models/users/collectors/collectorDto";
import { UserRoleType } from "../../../../core/models/users/userRoleType";
import { UserRoleName } from "../../../../shared/enums/userRolesName.enum";
import { LoaderService } from "../../../../core/services/loader.service";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { SaleOrderService } from "../../../../core/services/sale-order.service";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { UpdateUserDto } from "../../../../core/models/users/users/UpdateUserDto";
import { D365SynchronizerService } from "../../../../core/services/d365-synchronizer.service";
import { CommonModule } from "@angular/common";
import { ConfirmDialog } from "primeng/confirmdialog";
import { InputTextModule } from "primeng/inputtext";
import { MenuModule } from "primeng/menu";
import { ButtonModule } from "primeng/button";
import {
  ToggleSwitchChangeEvent,
  ToggleSwitchModule,
} from "primeng/toggleswitch";
import { CheckboxModule } from "primeng/checkbox";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { UserSupportMapComponent } from "../user-support-map/user-support-map.component";
import { UserProfileSecurityMapping } from "../../../../shared/constants/userProfileSecurityMapping";
import { UsersList } from "../../../../core/models/users/users/usersList";
import { MsalApiService } from "../../../../core/services/msal-api.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { SkeletonModule } from "primeng/skeleton";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { RadioButtonClickEvent, RadioButtonModule } from "primeng/radiobutton";
import { BillerCollectorService } from "../../../../core/services/biller-collector-service";
import { UserSupportMap } from "../../../../core/models/profile/userSupport";
import {
  FormErrors,
  RoleAccessDto,
  ValidationMessages,
} from "../../../../core/models/profile/form-validation.dto";
import { UnusedProject } from "../../../../core/models/profile/unusedProject";
import { UnusedPersonnelNumber } from "../../../../core/models/profile/unusedPersonnelNumber";
import { SelectModule } from "primeng/select";
import { DividerModule } from "primeng/divider";
import { UsersListingService } from "../../../../core/services/users-listing.service";

@UntilDestroy()
@Component({
  selector: "jni-profile-form",
  templateUrl: "./profile-form.component.html",
  standalone: true,
  imports: [
    CommonModule,
    ConfirmDialog,
    ReactiveFormsModule,
    InputTextModule,
    MenuModule,
    ButtonModule,
    ToggleSwitchModule,
    CheckboxModule,
    SelectModule,
    SkeletonModule,
    RadioButtonModule,
    DividerModule,
    FormsModule,
  ],
  providers: [ConfirmationService],
  encapsulation: ViewEncapsulation.None,
})
export class ProfileFormComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() profileForm!: FormGroup;
  @ViewChild("nameInput") nameInput!: ElementRef;
  isEditingName = false;
  skeleton_flag = false;
  @Input() userId = 0;
  getUserObject?: GenericResponseDto<GetUserDto>;
  unusedProjectList: UnusedProject[] = [];
  unusedPersonnelNumber: UnusedPersonnelNumber[] = [];
  userRoleId = 0;
  roleAccess!: RoleAccessDto;
  usertype = "other";
  selfUserType = "self";
  currentRoleId = 0;
  errorMessage = "Error occurred during synchronisation";
  successMessage = "Data synchronized successfully";
  queueSuccessMessage = "Sync in progress";
  showSmallLoader = false;
  disableSaveButton = true;
  isLedgerActive = false;
  isBillCollMandatory = false;
  sendEmailAs = "";
  confirmEmail: ConfirmUserEmailDto = new ConfirmUserEmailDto();
  @Output() supportTableForSelf = new EventEmitter<string>();
  currentUser = 0;
  loginUser = 0;
  loginUserId = 0;
  ledgerValue!: boolean;
  billerList: Biller[] = [];
  collectorList: Collector[] = [];
  loggedInUserIsAdmin = false;
  roleType: UserRoleType[] = [
    {
      id: 4,
      name: UserRoleName.Sales,
      isSelected: false,
    },
    { id: 3, name: UserRoleName.PowerUse, isSelected: false },
    {
      id: 5,
      name: UserRoleName.VR,
      isSelected: false,
    },
    {
      id: 2,
      name: UserRoleName.Manager,
      isSelected: false,
    },
    {
      id: 1,
      name: UserRoleName.Admin,
      isSelected: false,
    },
  ];

  formErrors: FormErrors = {
    employeeId: "",
    name: "",
    sendEmailAs: "",
    projectId: "",
    biller: "",
    collector: "",
  };

  validationMessages: ValidationMessages = {
    employeeId: {
      required: "Personnel Number is required",
    },
    name: {
      required: "Name is required",
    },
    sendEmailAs: {
      required: "Send Email As is required",
      email: "Invalid email Format",
    },
    projectId: {
      required: "Project is required.",
    },
    billerId: {
      required: "Biller is required",
    },
    collectorId: {
      required: "Collector is required",
    },
    displayEmailAs: {
      email: "Invalid email Format",
    },
  };
  isLedgerEmailNotification = false;
  userProfileSecurityMapping = UserProfileSecurityMapping;
  whoSupportMeTableData: UserSupportMap[] = [];
  whoSupportMeAddTableData: UsersList[] = [];

  whoISupportTableData: UserSupportMap[] = [];
  whoISupportAddTableData: UsersList[] = [];

  @ViewChild("whosupportsme", { static: false })
  whosupportsme!: UserSupportMapComponent;

  @ViewChild("whoisupport", { static: false })
  whoisupport!: UserSupportMapComponent;
  userEmail!: string;

  profileImage!: SafeUrl;
  userSupportDisplayModal = false;

  @Output() emitProfileFormChanges = new EventEmitter<FormGroup>();

  constructor(
    private _route: ActivatedRoute,
    private _toastr: JniToastrService,
    private _profileFormService: ProfileFormService,
    private _loaderService: LoaderService,
    private _d365SynchronizerService: D365SynchronizerService,
    private _loginService: UserManagementService,
    private _billerCollectorService: BillerCollectorService,
    private _saleOrderService: SaleOrderService,
    private confirmationService: ConfirmationService,
    private _msalApisService: MsalApiService,
    private _domSanitizer: DomSanitizer,
    private _usersListingService: UsersListingService
  ) {
    this._route.params.subscribe((params: Params) => {
      this.userId = params["id"];
      if (this.userId) {
        this.fetchAndSetLoggedInUserRole();
      }
    });
  }

  ngOnInit(): void {
    this.formEventListener();
    this.checkSuperMangerValidation();
  }

  logValidationErrors(group: FormGroup = this.profileForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  getUserRights() {
    const admin = Number(UserRole.Admin);
    const manager = Number(UserRole.Manager);
    if (
      this.loginUser != admin &&
      this.loginUser != manager &&
      this.loginUserId !== this.userId
    ) {
      this.profileForm.disable();
    }
  }

  getLoginUser(): Observable<boolean> {
    return this._loginService.validateLogin().pipe(
      map((res: GenericResponseDto<ValidateLogin>) => {
        if (res.data) {
          this.loginUser = res.data.userRoleId;
          this.loginUserId = res.data.userId;
          this.getUserRights();
          return true;
        }
        return false;
      })
    );
  }

  formEventListener() {
    this.profileForm.valueChanges.subscribe(values => {
      if (values.isLedgerActive) {
        this.isLedgerActive = true;
        this.disableSaveButton = false;
        if (!values.projectId) {
          this.disableSaveButton = true;
          this.profileForm.get("projectId")?.setValidators(Validators.required);
        }
        if (!values.billerId) {
          //this.disableSaveButton = true;
          //this.profileForm.get('billerId')?.setValidators(Validators.required);
        }
        if (!values.collectorId) {
          //this.disableSaveButton = true;
          //this.profileForm.get('collectorId')?.setValidators(Validators.required);
        }
      } else {
        this.isLedgerActive = false;
        this.disableSaveButton = false;
      }
      this.emitProfileFormChanges.emit(this.profileForm);
      this.isProfileActive = this.profileForm.get("isProfileActive")?.value;
    });
  }

  onLedgerChange() {
    if (this.ledgerValue) {
      this.isLedgerActive = true;
      this.disableSaveButton = false;
      this.isLedgerEmailNotification = true;
      this.enableLedger();
    } else {
      this.isLedgerActive = false;
      this.disableLedger();
      this.disableSaveButton = false;
      this.isLedgerEmailNotification = false;
    }
    this.setFieldLevelRoles();
  }

  enableLedger() {
    this.profileForm.get("projectId")?.enable();
    this.profileForm.get("billerId")?.enable();
    this.profileForm.get("collectorId")?.enable();
  }

  disableLedger() {
    this.profileForm.get("projectId")?.disable();
    this.profileForm.get("billerId")?.disable();
    this.profileForm.get("collectorId")?.disable();
  }

  getUserProfileData(id: number) {
    this._loaderService.setLoaderState(true);
    this._profileFormService
      .getUsersById(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: async res => {
          this.getUserObject = res;

          await this.getUnUsedPersonnelNumbers();
          await this.getUnUsedProjects();
          await this.getBillers();
          await this.getCollectors();
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.currentUser = res.data.userRoleId;
            this.fetchUserProfile(res.data.loginEmail);
          }

          if (res.data != null) {
            this.userTypeOnCheckbox(res.data.userRoleId);
            this.patchuserProfileData(this.getUserObject.data);
            if (res.data.sendEmailAs) {
              this.sendEmailAs = res.data.sendEmailAs;
            }

            if (res.data.isLedgerActive != null) {
              this.ledgerValue = res.data.isLedgerActive;
              this.onLedgerChange();
            }
          }
          if (this.usertype == "self" && res.data != null) {
            this.supportTableForSelf.emit(res.data.loginEmail);
          }
          const status = this.getLoginUser();
          if (status) {
            return;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  async getUnUsedPersonnelNumbers() {
    const res = await lastValueFrom(
      this._profileFormService
        .getUnusedPhoneNumber(this.userId?.toString())
        .pipe(untilDestroyed(this))
    );
    this.unusedPersonnelNumber = res.data;
  }

  async getUnUsedProjects() {
    const res = await lastValueFrom(
      this._profileFormService
        .getUnusedProject(this.userId?.toString())
        .pipe(untilDestroyed(this))
    );
    this.unusedProjectList = res.data;
  }

  async getBillers() {
    const res = await lastValueFrom(
      this._billerCollectorService.getAllBiller().pipe(untilDestroyed(this))
    );
    this.billerList = res.data;
  }

  async getCollectors() {
    const res = await lastValueFrom(
      this._billerCollectorService.getAllCollector().pipe(untilDestroyed(this))
    );
    this.collectorList = res.data;
  }

  patchuserProfileData(user: GetUserDto) {
    // this._profileFormService
    //   .getUserAccessJsonData()
    //   .pipe(untilDestroyed(this))
    //   .subscribe({
    //     next: () => {
    this.profileForm?.patchValue({
      id: this.userId,
      name: user.name,
      loginEmail: user.loginEmail,
      sendEmailAs: user.sendEmailAs,
      employeeId: user.employeeId != 0 ? user.employeeId : "",
      projectId: user.projectId,
      billerId: user.billerId,
      collectorId: user.collectorId,
      displayEmailAs: user.displayEmailAs,
      displayPhoneNumber: user.displayPhoneNumber,
      title: user.title,
      primaryBACEmail: user.primaryBACEmail,
      contactAddress: user.contactAddress,
      isProfileActive: user.isProfileActive,
      isConfirmed: user.isConfirmed,
      isLedgerActive: user.isLedgerActive,
      executiveLedgerAccess: user.executiveLedgerAccess,
      managerAccess: user.managerAccess,
      locationName: user.locationName,
      superManagerAccess: user.superManagerAccess,
      inventoryAccess: user.inventoryAccess,
      isBcIpEmailEnabled: user.isBcIpEmailEnabled,
      isBacIpEmailEnabled: user.isBacIpEmailEnabled,
      isBcCdiEmailEnabled: user.isBcCdiEmailEnabled,
      isBacCdiEmailEnabled: user.isBacCdiEmailEnabled,
    });
    this.skeleton_flag = true;
    //   },
    // });

    this.checkSuperMangerValidation();
  }

  setFieldLevelRoles() {
    const fields = [
      "name",
      "sendEmailAs",
      "employeeId",
      "projectId",
      "billerId",
      "collectorId",
      "displayEmailAs",
      "locationName",
      "displayPhoneNumber",
      "title",
      "primaryBACEmail",
      "isConfirmed",
      "contactAddress",
      "isProfileActive",
      "isLedgerActive",
      "executiveLedgerAccess",
      "managerAccess",
      "userRoleId",
      "superManagerAccess",
      "inventoryAccess",
    ];

    fields.forEach(field => {
      if (this.getIsFieldActive(field)) {
        const control = this.profileForm?.get(field);
        if (control) {
          control.disable();
        }
      }
    });
  }

  fetchAndSetLoggedInUserRole() {
    this._loginService.validateLogin().subscribe({
      next: res => {
        if (res) {
          this.userRoleId = res.data.userRoleId;
          if (res.data.userId == this.userId) {
            this.usertype = "self";
          }
          this.roleAccess = this.userProfileSecurityMapping;
          this.setFieldLevelRoles();
        }
      },
    });
  }

  getIsFieldActive(fieldname: string) {
    switch (this.userRoleId) {
      case UserRole.Sales:
      case UserRole.PowerUse:
        return this.getSalesUserRole(fieldname);
      case UserRole.Manager:
        return this.getMangerUserRole(fieldname);
      case UserRole.Admin:
        return this.getAdminUserRole(fieldname);
      case UserRole.VR:
        return this.getSalesUserRole(fieldname);
      default:
        return false;
    }
  }

  getSalesUserRole(fieldname: string) {
    const setUser = this.roleAccess
      ? this.roleAccess[fieldname][UserRoleName.Sales].self
      : "";
    if (setUser == "readonly") {
      return true;
    }
    return false;
  }

  getMangerUserRole(fieldname: string) {
    const setUser = this.roleAccess
      ? this.roleAccess[fieldname][UserRoleName.Manager].self
      : "";
    if (setUser == "readonly") {
      return true;
    }
    return false;
  }

  getAdminUserRole(fieldname: string) {
    const setUser = this.roleAccess
      ? this.roleAccess[fieldname][UserRoleName.Admin].self
      : "";
    if (setUser == "readonly") {
      return true;
    }
    return false;
  }

  userTypeOnCheckbox(getUserRole: number) {
    this.roleType.forEach(ele => {
      ele.isSelected = ele.id === getUserRole;
    });
    this.profileForm.patchValue({
      userRoleId: getUserRole,
    });
  }

  onSelected(event: RadioButtonClickEvent): void {
    const value = event.value;

    this.roleType.forEach(element => {
      if (element.id != value) {
        element.isSelected = false;
      } else {
        element.isSelected = true;
      }
    });
    this.profileForm.patchValue({
      userRoleId: value,
    });
    this.checkSuperMangerValidation();
  }

  onPersonnelNumberChangeProfile(event: number | Event): void {
    const obj = this.unusedPersonnelNumber.filter(x => x.id == event);
    if (obj.length > 0) {
      const isPresent = this.unusedProjectList.filter(
        x => x.projectId == obj[0]?.defaultProjectIdD365
      ).length;
      const firstName = obj[0]?.firstName ?? "";
      const lastName = obj[0]?.lastName ?? "";
      this.profileForm?.patchValue({
        name: firstName + " " + lastName,
        sendEmailAs: obj[0].sendEmailAs,
        employeeId: obj[0].id,
        projectId: isPresent > 0 ? obj[0]?.defaultProjectIdD365 : "",
        billerId: "",
        collectorId: "",
        displayEmailAs: obj[0].displayEmailAs,
        displayPhoneNumber: obj[0].displayPhoneNumber,
        title: obj[0].title,
        contactAddress: obj[0].contactAddress,
        isLedgerActive: obj[0].isLedgerActive,
        locationName: obj[0].locationName,
      });

      this.checkSuperMangerValidation();
      this.onLedgerChange();
    }
  }

  checkSendAsEmail() {
    const sendEmailAsValue: string = this.profileForm.get("sendEmailAs")?.value;
    if (
      typeof sendEmailAsValue === "string" &&
      RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$", sendEmailAsValue)
    ) {
      return true;
    }
    return false;
  }

  submitButtonlogValidationErrors(group: FormGroup = this.profileForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  updateUserProfileData() {
    this.submitButtonlogValidationErrors();
    const updateUserDto = this.profileForm.getRawValue() as UpdateUserDto;
    this._loaderService.setLoaderState(true);
    this.roleType.forEach(element => {
      if (element.isSelected) {
        this.currentRoleId = element.id;
        updateUserDto.userRoleId = this.currentRoleId;
      }
    });

    const isIPchecked = this.isIPEmailChecked();
    if (!isIPchecked) {
      this._toastr.error(
        "Error",
        "At least one IP email notification must be selected"
      );
      this._loaderService.setLoaderState(false);
      return;
    }

    const isCDIchecked = this.isCDIEmailChecked();
    if (!isCDIchecked) {
      this._toastr.error(
        "Error",
        "At least one CDI email notification must be selected"
      );
      this._loaderService.setLoaderState(false);
      return;
    }

    if (!this.profileForm.valid) {
      this._loaderService.setLoaderState(false);
      return;
    }

    this._profileFormService
      .updateUser(updateUserDto)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._toastr.success("Success", "User updated successfully");
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._toastr.error("Error", "Error updating user");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  generateReport() {
    this.confirmationService.confirm({
      message: "Are you sure you want to send out emails?",
      accept: () => {
        this._saleOrderService
          .getBacmReportMonthly()
          .pipe(untilDestroyed(this))
          .subscribe({
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });

        this._toastr.success(
          "Success",
          "Your Request has been received, Report will be sent out through Emails"
        );
      },
    });
  }

  refreshProfile() {
    this.showSmallLoader = true;
    this.syncD365ProjectsData();
    this.syncD365EmployeesProfileData();
  }

  syncD365ProjectsData() {
    this._d365SynchronizerService
      .syncD365ProjectsData()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.status == "Success") {
            this._toastr.success("Success", this.successMessage);
          } else {
            this._toastr.error("Error", this.errorMessage);
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this._toastr.error("Error", this.errorMessage);
          this.showSmallLoader = false;
        },
      });
  }

  syncD365EmployeesProfileData() {
    this._d365SynchronizerService
      .syncD365EmployeesProfileData()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          if (res.status == "Success") {
            this._toastr.success("Success", this.successMessage);
          } else {
            this._toastr.error("Error", this.errorMessage);
          }
        },
        error: () => {
          this._toastr.error("Error", this.errorMessage);
          this.showSmallLoader = false;
        },
      });
  }

  syncD365Data() {
    this.showSmallLoader = true;
    this._d365SynchronizerService
      .syncAllD365Data()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          if (res.status == "Success") {
            this._toastr.success("Success", this.queueSuccessMessage);
          } else {
            this._toastr.error("Error", this.errorMessage);
          }
        },
        error: () => {
          this.showSmallLoader = false;
          this._toastr.error("Error", this.errorMessage);
        },
      });
  }

  clickDisabled(event: Event): void {
    event.preventDefault();
  }

  ngOnChanges() {
    if (this.userId) {
      this.formEventListener();
      this.getUserProfileData(this.userId);
      this.fetchAndSetLoggedInUserRole();
      this.checkSuperMangerValidation();
    }
  }

  changeSuperManagerCheckbox(event: Event): void {
    if ((event?.target as HTMLInputElement)?.checked) {
      this.profileForm.patchValue({
        managerAccess: true,
      });
    }
  }

  changeTitle() {
    this.checkSuperMangerValidation();
  }

  changeType() {
    this.checkSuperMangerValidation();
  }

  checkSuperMangerValidation() {
    const value: string = this.profileForm.get("title")?.value || "";
    const userRoleTypeIsAdmin = this.roleType[4].isSelected;
    if (
      value &&
      !(
        value?.toLowerCase()?.includes("branding consultant") ||
        [
          "Chief Strategy Officer",
          "Branding Account Specialist",
          "Chief Financial Officer / Chief",
        ].includes(value)
      ) &&
      !userRoleTypeIsAdmin
    ) {
      this.profileForm.patchValue({
        superManagerAccess: false,
      });
      this.profileForm?.get("superManagerAccess")?.disable();
      this.profileForm?.get("managerAccess")?.disable();
    } else if (this.loggedInUserIsAdmin) {
      this.profileForm?.get("superManagerAccess")?.enable();
      this.profileForm?.get("managerAccess")?.enable();
    }
  }

  isIPEmailChecked() {
    const isBCIpEmail = this.profileForm?.get("isBcIpEmailEnabled")?.value;
    const isBacIpEmail = this.profileForm?.get("isBacIpEmailEnabled")?.value;
    if (!isBCIpEmail && !isBacIpEmail) {
      return false;
    } else {
      return true;
    }
  }

  isCDIEmailChecked() {
    const isBcCDIEmail = this.profileForm?.get("isBcCdiEmailEnabled")?.value;
    const isBacCDIEmail = this.profileForm?.get("isBacCdiEmailEnabled")?.value;
    if (!isBcCDIEmail && !isBacCDIEmail) {
      return false;
    } else {
      return true;
    }
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res.data != null) {
          if (res?.data?.userRoleId === UserRole.Admin) {
            this.profileForm?.get("userRoleId")?.enable();
            this.loggedInUserIsAdmin = true;
          } else {
            this.profileForm?.get("userRoleId")?.disable();
            this.profileForm?.get("superManagerAccess")?.disable();
            this.profileForm?.get("managerAccess")?.disable();
            this.profileForm?.get("executiveLedgerAccess")?.disable();
            this.profileForm?.get("inventoryAccess")?.disable();
            this.loggedInUserIsAdmin = false;
          }
        }
      },
    });
  }

  fetchUserProfile(loginEmail: string): void {
    this._msalApisService.getUserProfilePicture(loginEmail).subscribe({
      next: (res: Blob) => {
        const urlCreator = window.URL || window.webkitURL;
        this.profileImage = this._domSanitizer.bypassSecurityTrustUrl(
          urlCreator.createObjectURL(res)
        );
      },
      error: () => {
        this.profileImage = "../../../assets/images/avatar-default.webp";
      },
    });
  }

  ngAfterViewInit() {
    this.getUserProfile();
    this.getUserProfileData(this.userId);
  }

  toggleNameEdit(): void {
    const nameControl = this.profileForm.get("name");
    if (nameControl && !nameControl.disabled) {
      this.isEditingName = !this.isEditingName;
      if (
        this.isEditingName &&
        this.nameInput?.nativeElement instanceof HTMLElement
      ) {
        setTimeout(() => {
          if (this.nameInput?.nativeElement instanceof HTMLInputElement) {
            this.nameInput.nativeElement.focus();
          }
        });
      }
    }
  }

  isProfileActive = false;
  onProfileActiveToggleChanges(event: ToggleSwitchChangeEvent) {
    this.profileForm.get("isProfileActive")?.setValue(event.checked);
    this._usersListingService
      .UpdateUserProfileActive({
        id: this.profileForm?.get("id")?.value,
        isProfileActive: event.checked,
      })
      .subscribe(
        (res: GenericResponseDto<{ id: number; IsProfileActive: boolean }>) => {
          if (res.status.toLowerCase() === "success") {
            this._toastr.success(
              "Success",
              `Profile updated to ${event.checked ? "Active" : "Inactive"}`
            );
          } else {
            this._toastr.error("Error", "Error updating profile");
          }
        }
      );
  }
}
